import Component from '../Component';
import React from 'react';
import {ToggleButton} from 'reactis-inputs';
import immutable from 'immutable';
import GroupsInput from "./GroupsInput";

export default class Groups12Input extends Component {

	handleChange(g, value) {
		let v = this.props.value;
		if (!v) {
			v = immutable.List();
		}
		let v2 = v.set(g, value);
		this.props.onChange(v2);
	}

	render() {

		return (
			<div>
				&nbsp;I. <GroupsInput style={{display:'inline'}} value={this.props.value ? this.props.value.get(0) : null} onChange={(val) => this.handleChange(0, val)} /><br/>
				II. <GroupsInput style={{display:'inline'}} value={this.props.value ? this.props.value.get(1) : null} onChange={(val) => this.handleChange(1, val)} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Form/Groups12Input.js